<template>
  <div>
    <breadcrumbs home="Bulk container"/>

      <v-card flat>
        <v-form v-model="valid" ref="form">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
            <v-row dense>
              <v-col cols="6" sm="2">
                <v-text-field label="Number" v-model="bulkContainer.number" :rules="[fieldRules.required,fieldRules.maxLength(10)]" :counter="10" outlined dense/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6" lg="3">
                <v-autocomplete v-model="bulkContainer.typeId" outlined dense label="Container type"
                                :items="types" item-text="name" item-value="id">
                  <template v-slot:prepend-item>
                    <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="typeCreate=true">
                      <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new type
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" md="2">
                <decimal-number-input label="Shipping weight" v-model="bulkContainer.weight"  prefix="" suffix="kg" :precision="3"
                                      hint="Used for shipping"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="4" v-if="sites.length>1 && bulkContainerId === undefined">
                <v-autocomplete v-model="bulkContainer.initial.siteId" outlined dense label="Site"
                                :items="sites" item-text="name" item-value="id"/>
              </v-col>
              <v-col cols="6" sm="2">
                <v-text-field label="Location" v-model="bulkContainer.location" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense
                      hint="e.g. aisle, bin"/>
              </v-col>
            </v-row>

            <v-row v-if="bulkContainerId==undefined">
              <v-col cols="12" sm="7">
                <excise-vessel-initial :initial="bulkContainer.initial" :expand="false"/>
              </v-col>
            </v-row>

            <v-row dense v-if="bulkContainerId==undefined">
              <v-col cols="12">
                <v-text-field label="Comments" v-model="bulkContainer.initial.comments" outlined dense :rules="[fieldRules.maxLength(255)]" counter="255"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
    <inventory-bulk-containers-types-quick-create v-model="typeCreate" @create="typeCreated"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import InventoryBulkContainersTypesQuickCreate from '@/views/inventory/bulkContainers/InventoryBulkContainersTypesQuickCreate'
import ExciseVesselInitial from '@/views/equipment/exciseVessel/ExciseVesselInitial'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'InventoryBulkContainersEdit',
  mixins: [confirmLeave],
  components: {InventoryBulkContainersTypesQuickCreate,ExciseVesselInitial},
  props: {
    bulkContainerId: {type:String, required:false}
  },
  data () {
    return {
      types: [{name:'none',id:null}],
      bulkContainer: {weight:0,location:'',initial:{siteId:'',date:format(new Date(), 'yyyy-MM-dd HH:mm:ss'),volume:0,litres:0,kg:0,strength:0,value:0,lot:'',comments:'',alcoholId:''},typeId:null},
      dirty: false,
      saving: false,
      loading: true,
      valid: true,
      typeCreate:false,
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true, {B263:true,B265:true,B266:true});
    },
    values() {
      return this.$store.getters.company.permissions.includes('values');
    },
    pictureURL() {
      const type = this.types.find(type => type.id === this.bulkContainer.typeId);
      return type ? type.pictureURL : null;
    }
  },
  watch: {
    bulkContainer: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.$lazyListLoad(this.types, 'bulkContainerTypes2', 'id,name', 100);
    const results = await this.$apiCall(`query InventoryBulkContainersEdit($edit:Boolean!,$bulkContainerId:ID!) {
                                              bulkContainer(id:$bulkContainerId) @include(if:$edit) {
                                                id,number,location,weight,type{id}
                                              }
                                              nextBulkContainerNumber
                                            }`,
                                        {edit:this.bulkContainerId!=undefined,
                                         bulkContainerId:this.bulkContainerId || ''});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    if (this.bulkContainerId) {
      results.data.bulkContainer.typeId = results.data.bulkContainer.type ? results.data.bulkContainer.type.id : null;
      delete results.data.bulkContainer.type;
      this.bulkContainer = results.data.bulkContainer;
    }
    else {
      this.$set(this.bulkContainer, 'number', results.data.nextBulkContainerNumber);
      this.bulkContainer.initial.siteId = this.sites[0].id;
    }
    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },
  mounted() {
    this.$refs.form.validate();
  },

  methods: {
    typeCreated(type) {
      this.types.push(type);
      this.bulkContainer.typeId = type.id;
    },
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      const input = {...this.bulkContainer};
      if (this.bulkContainer.id)
        delete input.initial;
      const results = await this.$apiCall(`mutation InventoryBulkContainersEdit($input: BulkContainerInput!) {
                                             bulkContainerCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.bulkContainer.id?'Updated':'Created'} bulk container ${this.bulkContainer.number}`});
      }
    }
  }
}
</script>